import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Stepper from '../Stepper/Stepper';

const bem = new BEMHelper('QuantityStepper');

class QuantityStepper extends PureComponent {
    constructor(props) {
        super(props);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.state = {
            quantity: this.props.initialQuantity,
        };
    }

    componentDidUpdate(prevProps) {
        const { initialQuantity, shouldReset } = this.props;
        const initialQuantityChanged = initialQuantity !== prevProps.initialQuantity;
        const reset = !!shouldReset && !prevProps.shouldReset;

        if (initialQuantityChanged || reset) {
            this.resetQuantity();
        }
    }

    resetQuantity = () => {
        this.setState({ quantity: this.props.initialQuantity });
    };

    render() {
        const { className, disabled, maxQuantity, messages, minQuantity, orientation } = this.props;
        return (
            <div className={bem(null, null, className)}>
                <Stepper
                    disabled={disabled}
                    max={maxQuantity}
                    messages={messages}
                    min={minQuantity}
                    onChange={this.onQuantityChange}
                    orientation={orientation}
                    stepperValue={this.state.quantity}
                />
            </div>
        );
    }

    onQuantityChange(newQuantity) {
        this.setState({ quantity: newQuantity });
        this.props.onChange?.(newQuantity);
    }
}

QuantityStepper.propTypes = {
    minQuantity: PropTypes.number,
    maxQuantity: PropTypes.number,
    initialQuantity: PropTypes.number.isRequired,
    orientation: PropTypes.string,
    className: PropTypes.string,
    messages: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    shouldReset: PropTypes.bool,
};

QuantityStepper.defaultProps = {
    minQuantity: 1,
    maxQuantity: Number.MAX_SAFE_INTEGER,
    orientation: 'horizontal',
    initialQuantity: 1,
    disabled: false,
    shouldReset: false,
};

export default QuantityStepper;
